import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface LayoutsUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}
export const layoutsUpdated = createAction<LayoutsUpdatedPayload>('LAYOUTS_UPDATED');
